import SentimentIcon from "../../../components/SentimentIcon";
export default SentimentIcon;
